import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlipToFrontIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flip_to_front"}/>
}
